import React from "react";
import "./Leave.css";
import { useNavigate } from "react-router-dom";
import MobileLayout from "../../../layouts/MobileLayout";
import Leaveform from "./Leaveform";





const leaveData = [
    {
        title: "Casual Leave",
        remaining: 7,
        total: 12,
        used: 5,
    },
    {
        title: "Sick Leave",
        remaining: 6,
        total: 8,
        used: 5,
    },
    {
        title: "Priviledge Leave",
        remaining: 17,
        total: 20,
        used: 3,
    },
    {
        title: "Birthday Leave",
        remaining: 1,
        total: 1,
        used: 1,
    },
];

const Leave = () => {

    const navigate = useNavigate();
    return (

        <MobileLayout>
       
        {/* <div className="leave-page">
            <h2 className="leave-heading">Balance Leaves</h2>

            <div className="leave-grid">
                {leaveData.map((item, index) => {
                    const progress =
                        (item.remaining / item.total) * 100;

                    return (
                        <div className="leave-cards" key={index}>
                            <div className="leave-title">
                                {item.title}
                            </div>

                            <div className="leave-count-row">
                                <div className="leave-count">
                                    {item.remaining}/{item.total}
                                </div>

                                <span className="leave-used">
                                    {item.used} used
                                </span>
                            </div>

                            <div className="leave-progress">
                                <div
                                    className="leave-progress-fill"
                                    style={{
                                        width: `${progress}%`,
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>


            <button
                className="leave-apply-btn"
                onClick={() =>
                    navigate("/user/mobile/leaveform")
                }
            >
                Apply for Leave
            </button>

            <div className="leaverecent-requests">
                <h3 className="recent-title">Recent Requests</h3>

                <div className="request-card">
                    <div className="request-date">
                        <div className="date-range">10-14</div>
                        <div className="month">April</div>
                    </div>

                    <div className="request-divider"></div>

                    <div className="request-details">
                        <div className="request-type">Personal</div>
                        <div className="request-desc">
                            Casual Leave - 4days
                        </div>
                    </div>

                    <div className="request-status approved">
                        Approved
                    </div>
                </div>
            </div>
        </div> */}


        </MobileLayout>

        
    );
};

export default Leave;